/**
 * Returns the currently active role for the logged-in user.
 *
 * Priority (highest → lowest):
 *  1. localStorage 'currentRole'  — set explicitly by Switch Role or on first login
 *  2. user.role                   — backend single-role field (most specific)
 *  3. user.roles[0] / user.roleNames[0] — first entry in roles array
 *  4. user.userType               — legacy fallback
 */
export function getActiveRole(userData) {
  const stored = localStorage.getItem('currentRole');
  if (stored) return stored.toUpperCase();

  if (!userData) return '';

  const single =
    typeof userData.role === 'string' ? userData.role.toUpperCase() : null;
  if (single) return single;

  const arr = userData.roleNames || userData.roles;
  if (Array.isArray(arr) && arr.length > 0) {
    const first = arr[0];
    return (typeof first === 'string' ? first : first?.roleName || '').toUpperCase() || '';
  }
  if (typeof arr === 'string') return arr.toUpperCase();

  if (userData.userType) return userData.userType.toUpperCase();

  return '';
}

/**
 * Reads the user object from localStorage and returns the active role.
 * Convenience wrapper for components that haven't parsed user data yet.
 */
export function getActiveRoleFromStorage() {
  const stored = localStorage.getItem('currentRole');
  if (stored) return stored.toUpperCase();

  try {
    const raw = localStorage.getItem('user');
    if (!raw) return '';
    return getActiveRole(JSON.parse(raw));
  } catch {
    return '';
  }
}
